import type { PlatformEntryContext } from '@/types';

export const OWNER_ASSISTANT_ROUTE = '/owner/assistant';

export function resolveOwnerAssistantAccess(
  entryContext: PlatformEntryContext | null | undefined,
): { allowed: boolean; redirectTo: string } {
  if (!entryContext) return { allowed: false, redirectTo: '/access-pending' };
  if (entryContext.is_platform_owner !== true) {
    return { allowed: false, redirectTo: '/dashboard' };
  }
  return { allowed: true, redirectTo: OWNER_ASSISTANT_ROUTE };
}
